module.exports = __webpack_public_path__ + "img/1574748794.a5a03f31.jpg";